import React, { Component, createRef } from "react";
// CSS
import "./Students.scss";

// Helper
import { apiFetch, getCurrentUser } from "../../Helper/Api";

// Components
import Header from "../../components/Header/Header";
import { Modal, Confirm } from "../../components/UI/Overlays";
import { EmptyState, TableWait, Alert, UserCell, StatTile, Tip, Chip } from "../../components/UI/Feedback";
import { Toolbar, SelectEmpty } from "../../components/UI/Controls";
import { Toast } from "primereact/toast";
import { Card } from "primereact/card";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";

// Properties
const properties = require("../../properties.json");

class SubStudents extends Component {
  constructor(props) {
    super(props);
    this.toast = createRef(null);
  }

  state = {
    globalFilter: null,

    // Teacher Identifier
    branchID: getCurrentUser()?.branchId,

    // Data
    data: [],
    getPeriodsList: [],

    // Update Data
    resend: false,

    teacherId: null,
    selectedPeriod: null,
    selectedPeriodId: null,

    visible: false,
    studentId: null,
    studentPassword: null,
    studentEmail: null,
    studentCode: null,

    // ---- the page's own states, so nothing is ever a blank wait ----
    tableLoading: true,
    loadingPeriods: true,

    // ids resolved to the names the teacher knows
    stagesById: {},

    // the enrolment the teacher asked to remove, held while the question is up
    doomed: null,
    deleting: false,

    // the student whose password is about to be replaced
    resetting: null,
    resetBusy: false,
  };

  getPeriods = () => {
    this.setState({ loadingPeriods: true });
    apiFetch("/periods")
      .then((fetchPeriods) => {
        this.setState({
          getPeriodsList: fetchPeriods,
          loadingPeriods: false,
        });
      })
      .catch((error) => {
        this.setState({ loadingPeriods: false });
        console.error("Error:", error);
      });
  };

  // A row carries the id of the stage it belongs to; this turns it into the
  // name the teacher knows it by. Same shape as the lessons page.
  getStages = () => {
    apiFetch("/lookup/school-stages/by-teacher", { query: { teacherUserId: getCurrentUser()?.userId } })
      .then((stages) => {
        const stagesById = {};
        stages.forEach((s) => {
          stagesById[s.id] = s.name;
        });
        this.setState({ stagesById });
      })
      .catch((error) => console.error("Error:", error));
  };

  getStudents = (periodId) => {
    this.setState({ tableLoading: true });
    apiFetch("/students/enrollments", { query: { periodId } })
      .then((fetchStudents) => {
        this.setState({
          data: fetchStudents,
          tableLoading: false,
        });
      })
      .catch((error) => {
        this.setState({ tableLoading: false });
        console.error("Error:", error);
      });
  };

  viewStudent = (R) => {};

  // The question is asked in the product's own card, never the browser's;
  // everything after "yes" is the call it always was.
  deleteStudent = (id, studentId, pId) => {
    var _this = this;

    this.setState({ deleting: true });

    apiFetch(`/students/enrollments/${id}`, { method: "DELETE" })
      .then(() => {
        _this.toast.current.show({
          severity: "success",
          summary: "تمت العملية",
          detail: "تم الحذف بنجاح",
        });
        this.setState({ doomed: null, deleting: false });
        this.getStudents(pId);
      })
      .catch((error) => {
        console.error("Error:", error);

        this.setState({ doomed: null, deleting: false });

        _this.toast.current.show({
          severity: "error",
          summary: "لم تتم العملية",
          detail: "خطأ في الإتصال",
        });
      });
  };

  /** Passwords are bcrypt-hashed now (never shown in plaintext) -- this generates and shows a NEW one. */
  resetStudent = (studentProfileId) => {
    var _this = this;

    this.setState({ resetBusy: true });

    apiFetch(`/students/${studentProfileId}/reset-password`, { method: "POST" })
      .then((result) => {
        this.setState({
          studentPassword: result.newPassword,
          visible: true,
          studentId: studentProfileId,
          resetting: null,
          resetBusy: false,
        });
        _this.toast.current.show({
          severity: "success",
          summary: "تمت العملية",
          detail: "تم إنشاء كلمة مرور جديدة",
        });
      })
      .catch((error) => {
        console.error("Error:", error);

        this.setState({ resetting: null, resetBusy: false });

        _this.toast.current.show({
          severity: "error",
          summary: "لم تتم العملية",
          detail: "خطأ في الإتصال",
        });
      });
  };

  componentDidMount() {
    this.getPeriods();
    this.getStudents();
    this.getStages();

    document.title = properties.site_name + " | طلابي";
  }

  //   componentDidUpdate(prevProps, prevState, snapshot) {
  //     if (prevState.resend !== this.state.resend) {
  //       this.getStudents();

  //       this.setState({ resend: false });
  //     }
  //   }

  render() {
    const { tableLoading, data, doomed, deleting, resetting, resetBusy } = this.state;

    let periodList = this.state.getPeriodsList.map((period) => {
      return { label: period.name, value: period.id };
    });

    // the one filter this page has, kept exactly as it was: choosing a
    // period refetches for that period, clearing it refetches for all
    const pickPeriod = (value) => {
      this.setState({
        selectedPeriod: value,
        globalFilter: undefined,
      });

      this.getStudents(value);
    };

    const chosenPeriod = this.state.getPeriodsList.find(
      (p) => p.id === this.state.selectedPeriod
    );

    // one dropdown belongs on the bar, not behind a drawer. No label over it
    // either: "كل الفترات" already says what it is and what it is set to.
    const tools = (
      <span className="ui-filter is-inline">
          <Dropdown
            value={this.state.selectedPeriod}
            options={periodList}
            placeholder="كل الفترات"
            onChange={(e) => pickPeriod(e.value)}
            optionLabel="label"
            showClear
            emptyMessage={<SelectEmpty loading={this.state.loadingPeriods} text="مفيش فترات" />}
          />
      </span>
    );

    // what the rows add up to, read before the rows themselves
    const money = data.reduce((sum, r) => sum + Number(r.value || 0), 0);
    const periodsInUse = new Set(data.map((r) => r.periodName).filter(Boolean)).size;

    const actionBodyTemplate = (rowData) => {
      return (
        <React.Fragment>
          <Tip text="كلمة سر جديدة">
            <Button
              icon="pi pi-refresh"
              className="p-button-rounded p-button-warning p-ml-2"
              onClick={() => this.setState({ resetting: rowData })}
            />
          </Tip>
          <Tip text="شيل الطالب من الفترة">
            <Button
              icon="pi pi-trash"
              className="p-button-rounded p-button-danger"
              onClick={() => this.setState({ doomed: rowData })}
            />
          </Tip>
        </React.Fragment>
      );
    };

    // the student as the teacher knows them: their name, with the number
    // they are reached on underneath
    const nameBody = (row) => (
      <UserCell name={row.studentName} sub={row.studentMobile || "من غير رقم"} />
    );

    // where the enrolment sits: the period, with its stage under it
    const placeBody = (row) => (
      <span className="ui-stack">
        <b>{row.periodName || "—"}</b>
        <small>{this.state.stagesById[row.schoolStagesId] || "—"}</small>
      </span>
    );

    const moneyBody = (row) =>
      row.value === null || row.value === undefined || row.value === "" ? (
        <Chip kind="off">من غير مبلغ</Chip>
      ) : (
        <span className="ui-money">
          <b>{Number(row.value).toLocaleString("en-US")}</b>
          <small>ج.م</small>
        </span>
      );

    return (
      <>
        <Header pageName="طلابي" />

        <Toast ref={this.toast}></Toast>

        {/* shelving an enrolment, and replacing a password: two questions
            that are not the same colour, asked in the same card */}
        <Confirm
          visible={!!doomed}
          onHide={() => this.setState({ doomed: null })}
          name={doomed ? doomed.studentName : ""}
          note={
            doomed
              ? `الطالب هيتشال من فترة «${doomed.periodName || "—"}» ومش هيقدر يدخل دروسها.`
              : ""
          }
          busy={deleting}
          onConfirm={() =>
            this.deleteStudent(doomed.id, doomed.studentProfileId, doomed.periodId)
          }
        />

        <Confirm
          visible={!!resetting}
          onHide={() => this.setState({ resetting: null })}
          tone="warn"
          icon="pi pi-refresh"
          title={resetting ? `تعمل كلمة سر جديدة لـ «${resetting.studentName}»؟` : ""}
          note="القديمة هتبطل على طول، والجديدة هتظهر لك مرة واحدة بس — انسخها وابعتها للطالب."
          confirmLabel="أيوه، اعمل واحدة جديدة"
          busyLabel="بنعمل كلمة سر…"
          busy={resetBusy}
          onConfirm={() => this.resetStudent(resetting.studentProfileId)}
        />

        <div className="content">
          <div className="container">
            <div className="card">
              <Card>
                {/* three numbers that answer "كام طالب ومن أنهي فترة" before
                    a single row is read */}
                <div className="ui-tiles">
                  <StatTile
                    brand
                    icon="pi pi-users"
                    label="طلابي"
                    value={tableLoading ? "…" : data.length}
                  />
                  <StatTile
                    icon="pi pi-calendar"
                    tone="teal"
                    label="فترات فيها طلاب"
                    value={tableLoading ? "…" : periodsInUse}
                  />
                  <StatTile
                    icon="pi pi-wallet"
                    tone="gold"
                    label="إجمالي الاشتراكات"
                    value={tableLoading ? "…" : `${money.toLocaleString("en-US")} ج.م`}
                  />
                </div>

                <Toolbar
                  value={this.state.globalFilter || ""}
                  onSearch={(v) => this.setState({ globalFilter: v })}
                  placeholder="بحث باسم الطالب أو رقمه"
                  count={tableLoading ? null : `${data.length} طالب`}
                  tools={tools}
                />

                <DataTable
                  sortable
                  globalFilter={this.state.globalFilter}
                  className="p-datatable-responsive-demo p-datatable-gridlines p-datatable-striped"
                  value={data}
                  paginator
                  rows={10}
                  rowsPerPageOptions={[10, 20, 50]}
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                  emptyMessage={
                    tableLoading ? (
                      <TableWait />
                    ) : chosenPeriod ? (
                      <EmptyState
                        title={`مفيش طلاب في «${chosenPeriod.name}»`}
                        hint="جرّب فترة تانية، أو شيل الفلتر وشوف كل طلابك"
                        icon="pi pi-users"
                        action={{ label: "اعرض كل الفترات", onClick: () => pickPeriod(null) }}
                      />
                    ) : (
                      <EmptyState
                        title="مفيش طلاب عندك لسه"
                        hint="الطالب بيظهر هنا بعد ما تفعّل اشتراكه في فترة"
                        icon="pi pi-users"
                        secondary={{ label: "تفعيل الطلاب", url: "/students" }}
                      />
                    )
                  }
                >
                  <Column
                    sortable
                    field="studentName"
                    header="الطالب"
                    body={nameBody}
                  ></Column>
                  <Column
                    sortable
                    field="studentMobile"
                    header="رقم التلفون"
                    style={{ width: "160px" }}
                  ></Column>
                  <Column
                    sortable
                    field="periodName"
                    header="الفترة والمرحلة"
                    body={placeBody}
                    style={{ width: "200px" }}
                  ></Column>
                  <Column
                    sortable
                    field="value"
                    header="الاشتراك"
                    body={moneyBody}
                    style={{ width: "150px" }}
                  ></Column>

                  <Column header="إعادة ضبط / حذف" body={actionBodyTemplate}></Column>
                </DataTable>
              </Card>
            </div>
          </div>

          {/* the new password, shown once: the one thing on the card is the
              password itself */}
          <Modal
            visible={this.state.visible}
            onHide={() => this.setState({ visible: false })}
            title="كلمة السر الجديدة"
            width={460}
            footer={
              <button
                type="button"
                className="ui-btn"
                onClick={() => this.setState({ visible: false })}
              >
                <i className="pi pi-check"></i>
                <span>نسختها، اقفل</span>
              </button>
            }
          >
            <div className="ui-secret">
              <InputText
                readOnly
                tooltip="كلمة المرور الجديدة"
                value={this.state.studentPassword || ""}
              ></InputText>
            </div>

            <Alert kind="warn" title="مش هتظهر تاني">
              ابعت كلمة السر دي للطالب دلوقتي — بعد ما تقفل النافذة مش هينفع
              تشوفها مرة تانية، هتضطر تعمل واحدة جديدة.
            </Alert>
          </Modal>
        </div>
      </>
    );
  }
}

export default SubStudents;
